import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
export const importSchemeGenericApi = createApi({
    reducerPath: "importSchemeGeneric",
    baseQuery,
    tagTypes: ["importSchemeGeneric"],
    endpoints: (builder) => ({
     
        createSchemeGeneric: builder.mutation({
            query: ({ id,...data }) => ({
              url: `import/product/schemeGeneric/${id}`, 
              method: "PUT",
              headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
              body: { productGeneral:data },
            }),
            invalidatesTags: ["importSchemeGeneric"],
          }),
          updateSchemeGeneric: builder.mutation({
            query: ({ id,subId, ...data }) => ({
              url: `import/product/schemeGeneric/${id}/${subId}`,
              method: "PUT",
              headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
              body: { productGeneral:data },
            }),
            invalidatesTags: ["importSchemeGeneric"],
          }),

          getSchemeById: builder.query({
            query: ({id}) => `import/product/schemeGeneric/${id}`,
            transformResponse: (response) => response?.data,
            providesTags: ["importSchemeGeneric"],
          }), 






      }), 
    });

    export const {
        useCreateSchemeGenericMutation,
        useUpdateSchemeGenericMutation,
        useLazyGetSchemeByIdQuery

       
        
  
        } = importSchemeGenericApi;
